<template>
	<div class="gc-header">
		<div class="bg-desktop" :style="'background-image:url(' +  wpNavOptions.page_bg_desktop + ')'"></div>
		<div class="bg-mobile" :style="'background-image:url(' +  wpNavOptions.page_bg_mobile + ')'"></div>
		<div class="gc-wrapper">
			<h1 class="cat_title">{{wpNavOptions.header_title}}</h1>
			<p class="desc">{{ wpNavOptions.header_text }}</p>
		</div>
	</div>
</template>

<script>
	export default {

		name: 'GiftCardHeader',

		data () {
			return {
				wpData: wpData,
				wpNavOptions: wpData.globalOptions.gc_purchase_nav
			}
		}
	}
</script>

<style lang="sass" scoped>

	@import '../../assets/sass/gift-card-abstracts.sass'

	.gc-header

		padding-top: 5rem
		+tablet
			padding-top: 0

		.wrapper
			padding-top: 5rem
			padding-bottom: 3rem
			+mobile
				padding-top: 2rem

		.bg-desktop
			position: fixed
			z-index: 1
			top: auto
			bottom: 0
			left: 0
			width: 30%
			height: 100%
			max-height: calc(100vh - 250px)
			background-size: contain
			background-repeat: no-repeat
			background-position: left bottom
			transform: translateY(-96px)
			+tablet
				display: none
		
		.bg-mobile
			display: none
			height: 50vw
			background-size: cover
			background-position: center top
			position: relative
			margin-bottom: -1rem
			&:after
				content: ''
				position: absolute
				bottom: 0
				left: 0
				height: 5rem
				width: 100%
				background: linear-gradient(0deg, rgba($bg,1) 0%, rgba(255,255,255,0) 100%)

			+tablet
				display: block

		.cat_title
			margin-bottom: 1rem
			+tablet
				margin-top: 2rem
			+mobile
				font-size: 2rem

		.desc
			font-weight: bold
			max-width: 50rem
			line-height: 1.45
			white-space: pre-line
			+mobile
				max-width: 100%
</style>

<style lang="sass">
	@import '../../assets/sass/gift-card-abstracts.sass'
	+mobile
		.acsb-trigger
			display: none !important
</style>